import "./App.css";
import csvFile from "./data.csv";
import { useEffect, useState } from "react";
import Papa from "papaparse";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import amplitude from "amplitude-js";

import { MoreToolsModal, useAutomatedModalState } from "./MoreToolsModal";
//TBD: Move to utils

amplitude.getInstance().init("48979423ae2c7c8a1b72218baf99fbfc");

function compare(a, b) {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
}

let records = {};
let countryOptions = [
  {
    label: "Australia",
    value: "AU",
  },
  {
    label: "Spain",
    value: "ES",
  },
  {
    label: "France",
    value: "FR",
  },
  {
    label: "Germany",
    value: "DE",
  },
  {
    label: "Italy",
    value: "IT",
  },
  {
    label: "Canada",
    value: "CA",
  },
  {
    label: "United Kingdom",
    value: "GB",
  },
  {
    label: "United States of America",
    value: "US",
  },
  {
    label: "India",
    value: "IN",
  },
  {
    label: "Portugal",
    value: "PT",
  },
  {
    label: "Romania",
    value: "RO",
  },
];

let tierOptions = [
  {
    label: "Statutory",
    value: "statutory",
  },
  {
    label: "Bronze (Basic Benefits)",
    value: "base",
  },
  {
    label: "Silver (Locally Competitive Benefits)",
    value: "good",
  },
  {
    label: "Gold (Best-in-class Exclusive Benefits)",
    value: "top",
  },
];

function getTierValue(type) {
  let tierValue = 0;
  switch (type) {
    case "statutory":
      tierValue = 0;
      break;
    case "base":
      tierValue = 1;
      break;
    case "good":
      tierValue = 2;
      break;
    case "top":
      tierValue = 3;
      break;
    default:
      tierValue = 0;
  }
  return tierValue;
}

Papa.parse(csvFile, {
  download: true,
  complete: function (input) {
    input.data.forEach((element) => {
      const countryCode = element[2];
      if (countryCode !== "api_iso_alpha2_code") {
        if (!records.hasOwnProperty(countryCode)) {
          records[countryCode] = [
            {
              id: element[0],
              type: element[3],
              tierValue: getTierValue(element[3]),
              name: element[1],
              notes: element[4].trim(),
            },
          ];
        } else {
          records[countryCode].push({
            id: element[0],
            type: element[3],
            tierValue: getTierValue(element[3]),
            name: element[1],
            notes: element[4].trim(),
          });
        }
      }
    });
  },
});

function App() {
  const [country, setCountry] = useState();
  const [tier, setTier] = useState();
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [toggleInfo, setToggleInfo] = useState(false);

  const { isModalOpen, onModalClose, triggerActionCounter } =
      useAutomatedModalState(3);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const updateCountry = triggerActionCounter((selectedValue) => {
    const event = "benefits_advisor_submit";
    const eventProperties = {
      country: selectedValue.label,
      tier,
    };
    amplitude.getInstance().logEvent(event, eventProperties);

    setCountry(selectedValue.value);
    const keys = Object.keys(records);
    keys.forEach((key) => {
      if (selectedValue.value === key) {
        setSelectedRecord(records[key]);
      }
    });
  });

  const updateTier = (selectedValue) => {
    if (country) {
      const event = "benefits_advisor_submit";
      const eventProperties = {
        country: countryOptions.find((element) => element.value === country)
          .label,
        tier: selectedValue.value,
      };
      amplitude.getInstance().logEvent(event, eventProperties);
    }
    setTier(selectedValue.value);
  };

  const renderBenefit = (item) => {
    if (getTierValue(item.type) <= getTierValue(tier)) {
      return (
        <div key={item.id} className="inline-flex p-2 mt-4 mr-2 bg-gray-100 rounded-lg">
          <div> {item.name} </div>
          {item.type === "statutory" && (
            <div className="self-center px-2 py-1 ml-2 text-xs bg-pink-400 rounded-md text-info-darken-100">
              Statutory
            </div>
          )}

          {item.notes && (
            <span
              className="px-2 ml-2 font-bold text-gray-500 border border-gray-500 rounded-full"
              data-tip={item.notes}
            >
              i
            </span>
          )}
        </div>
      );
    }
  };

  return (
    <>
      <MoreToolsModal isOpen={isModalOpen} onClose={onModalClose} />
      <ReactTooltip multiline={true} className="tooltip" />
      <div className="max-w-6xl pt-12 m-auto">
        <div className="grid-cols-2 gap-4 md:grid">
          <div>
            <span className="font-bold">I want to offer benefits in</span>
            <Select
              options={countryOptions.sort(compare)}
              onChange={updateCountry}
              placeholder={<div>Please select a country</div>}
            />
          </div>
          <div className="pt-4 md:pt-0">
            <span className="font-bold">My approach is</span>
            <Select
              options={tierOptions}
              onChange={updateTier}
              placeholder={<div>Please select a package</div>}
            />
            <div
              onClick={() => setToggleInfo(!toggleInfo)}
              className="text-sm font-bold underline cursor-pointer text-sky-600"
            >
              What do the packages mean?
            </div>
          </div>
        </div>

        <div className="mt-2">
          {toggleInfo && (
            <div className="p-4 bg-gray-100 border border-gray-100 rounded-md">
              Get all the intel on country-specific benefits. Find answers to
              “What’s statutory and what’s best-in-class in Italy?” or “Can I
              offer the same benefits in the UK and Canada?” The benefits are
              categorized into four tiers.
              <br />
              <br />
              <span className="font-bold uppercase">Gold Package</span>{" "}
              Best-in-class benefits that will help you stand out. Only 5% of
              companies we analyzed offer this.
              <br />
              <br />
              <span className="font-bold uppercase">Silver Package</span>{" "}
              Locally optimized benefits offered by 25% of the companies we
              analyzed.
              <br />
              <br />
              <span className="font-bold uppercase">BRONZE PACKAGE</span> Basic
              extended benefits offered by 60% of the companies we analyzed.
              <br />
              <br />
              <span className="font-bold uppercase">STATUTORY</span> These
              benefits are required by law and are already included in your
              Oyster fee.
              <br />
              <br />
              <a
                href="https://support.oysterhr.com/hc/en-us/articles/4946462040465"
                rel="noreferrer"
                target="_blank"
                className="text-sm font-bold underline text-sky-600"
              >
                Learn about the advisor, our data sources, and the benefits you
                can offer with Oyster
              </a>
            </div>
          )}
        </div>

        {country && tier ? (
          <>
            <div className="p-4 mt-8 rounded ">
              <div className="text-xl font-bold">
                {tierOptions.find((element) => element.value === tier).label} in{" "}
                {
                  countryOptions.find((element) => element.value === country)
                    .label
                }
              </div>
              <div className="pb-4">
                <div>{country.rules}</div>
              </div>
              {selectedRecord.map((item) => renderBenefit(item))}
            </div>
          </>
        ) : (
          <div className="p-4 m-auto mt-8 text-center rounded md:max-w-3xl bg-gray-50">
            <div className="text-xl font-bold">
              Not sure what benefits to offer?
            </div>
            <p className="">
              We’re here to help! Select your hiring country and approach above
              to identify a list of statutory and extended benefits companies in
              those locations are offering.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default App;
